module.exports = __webpack_public_path__ + "img/oran_6kl.07e6fe0c.jpg";